import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['a', 'b', 'i', 'em', 'strong', 'p', 'br', 'span', 'div', 'ul', 'ol', 'li'];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'style', 'class'];

export const sanitizeHtml = (dirty: string): string => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
};

export const createSafeHtml = (dirty: string): { __html: string } => {
  return { __html: sanitizeHtml(dirty) };
};
